<template>
   <div>
       <div class="contact-info wow fadeInRight" data-wow-duration="2s" v-for="location in locations">
           <h3>{{ location.name }}</h3>
           <div class="d-flex justify-content-between">
               <a href="" class="link">
                   <i class="fas fa-map-marker-alt"></i>{{ location.address }}
               </a>
               <a :href="`tel:${location.phone}`" class="link">
                   <i class="fas fa-phone-alt"></i>{{ location.phone }}
               </a>
           </div>
           <div class="map-holder">
               <GoogleMap
                   :input_map_height="`20.625rem`"
                   :input_map_center="{ lat : parseFloat(location.lat), lng : parseFloat(location.lng) }"
                   :input_map_zoom="16"
                   :input_map_center_default="true"
                   :input_marker_image="`/img/marker-blue.png`"
               ></GoogleMap>
           </div>
       </div>
   </div>
</template>

<script>
    import GoogleMap from "../../../../../../resources/js/components/GoogleMap";

    export default {
        name: "ContactMap",
        components: { GoogleMap },
        props: {
            locations: {
                type: Array,
                required: false
            }
        }
    }
</script>
